import configurator from "./configurator";
import deleteDialog from "./delete_dialog";
import entities from "./entities";
import loadingCard from "./loading_card";
import manage from "./manage";
import management from "./management";
import navBar from "./nav_bar";
import notAvailableCard from "./not_available_card";
import overview from "./overview";
import overviewTable from "./overview_table";
import status from "./status";
import statusDialog from "./status_dialog";
import template from "./template";
import updateStatus from "./update_status";

const vps = {
	configurator: configurator,
	delete_dialog: deleteDialog,
	entities: entities,
	loading_card: loadingCard,
	manage: manage,
	management: management,
	nav_bar: navBar,
	not_available_card: notAvailableCard,
	overview: overview,
	overview_table: overviewTable,
	status: status,
	status_dialog: statusDialog,
	template: template,
	title: "VPS",
	update_status: updateStatus,
};

export default vps;
